import { subDays } from 'date-fns';
export var mockData = [
    {
        id: 150,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 29).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 319,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 145,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 29).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 314,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 148,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 29).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 316,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 149,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 29).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 318,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 153,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 29).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 322,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 154,
        workspaceId: 6,
        userId: 8,
        date: subDays(new Date(), 29).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 323,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 144,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 29).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 313,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 146,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 29).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 315,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 147,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 29).toISOString(),
        value: 27,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 317,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 151,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 29).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 320,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 152,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 29).toISOString(),
        value: 95,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 321,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 141,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 28).toISOString(),
        value: 11,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 297,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 142,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 28).toISOString(),
        value: 11,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 298,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 139,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 28).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 296,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 140,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 28).toISOString(),
        value: 16,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 295,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 143,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 28).toISOString(),
        value: 81,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 299,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 133,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 27).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 290,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 135,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 27).toISOString(),
        value: 5,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 291,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 136,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 27).toISOString(),
        value: 5,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 292,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 138,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 27).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 294,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 134,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 27).toISOString(),
        value: 7,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 289,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 137,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 27).toISOString(),
        value: 107,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 293,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 126,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 26).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 277,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 128,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 26).toISOString(),
        value: 10,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 279,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 129,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 26).toISOString(),
        value: 10,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 278,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 131,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 26).toISOString(),
        value: 9,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 281,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 132,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 26).toISOString(),
        value: 6,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 282,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 125,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 26).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 276,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 127,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 26).toISOString(),
        value: 16,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 275,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 130,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 26).toISOString(),
        value: 66,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 280,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 122,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 25).toISOString(),
        value: 7,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 265,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 123,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 25).toISOString(),
        value: 8,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 267,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 121,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 25).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 266,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 124,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 25).toISOString(),
        value: 33,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 268,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 116,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 24).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 251,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 118,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 24).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 253,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 119,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 24).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 254,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 117,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 24).toISOString(),
        value: 6,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 252,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 120,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 24).toISOString(),
        value: 48,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 255,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 111,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 23).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 231,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 104,
        workspaceId: 6,
        userId: 2,
        date: subDays(new Date(), 23).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 226,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 106,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 23).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 225,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 109,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 23).toISOString(),
        value: 8,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 229,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 110,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 23).toISOString(),
        value: 5,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 230,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 114,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 23).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 234,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 115,
        workspaceId: 6,
        userId: 8,
        date: subDays(new Date(), 23).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 235,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 105,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 23).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 224,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 107,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 23).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 228,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 108,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 23).toISOString(),
        value: 25,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 227,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 112,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 23).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 232,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 113,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 23).toISOString(),
        value: 48,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 233,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 101,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 22).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 220,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 99,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 22).toISOString(),
        value: 7,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 216,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 100,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 22).toISOString(),
        value: 7,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 219,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 103,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 22).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 221,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 98,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 22).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 217,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 102,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 22).toISOString(),
        value: 24,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 218,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 92,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 21).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 212,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 95,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 21).toISOString(),
        value: 7,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 213,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 96,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 21).toISOString(),
        value: 8,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 214,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 91,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 21).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 210,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 93,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 21).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 209,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 94,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 21).toISOString(),
        value: 11,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 211,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 97,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 21).toISOString(),
        value: 44,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 215,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 89,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 20).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 204,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 87,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 20).toISOString(),
        value: 6,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 202,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 88,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 20).toISOString(),
        value: 6,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 203,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 84,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 20).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 200,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 85,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 20).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 199,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 86,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 20).toISOString(),
        value: 10,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 201,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 90,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 20).toISOString(),
        value: 24,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 205,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 78,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 19).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 185,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 81,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 19).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 188,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 82,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 19).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 189,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 77,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 19).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 184,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 79,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 19).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 186,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 80,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 19).toISOString(),
        value: 24,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 187,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 83,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 19).toISOString(),
        value: 21,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 190,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 75,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 18).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 174,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 73,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 18).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 171,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 74,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 18).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 172,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 72,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 18).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 170,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 76,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 18).toISOString(),
        value: 9,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 173,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 68,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 17).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 162,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 69,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 17).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 164,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 65,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 17).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 161,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 66,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 17).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 163,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 67,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 17).toISOString(),
        value: 6,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 160,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 70,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 17).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 165,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 71,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 17).toISOString(),
        value: 15,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 166,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 60,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 16).toISOString(),
        value: 8,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 151,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 54,
        workspaceId: 6,
        userId: 2,
        date: subDays(new Date(), 16).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 146,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 56,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 16).toISOString(),
        value: 7,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 147,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 58,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 16).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 148,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 59,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 16).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 150,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 63,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 16).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 154,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 64,
        workspaceId: 6,
        userId: 8,
        date: subDays(new Date(), 16).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 155,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 55,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 16).toISOString(),
        value: 16,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 145,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 57,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 16).toISOString(),
        value: 17,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 149,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 61,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 16).toISOString(),
        value: 9,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 152,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 62,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 16).toISOString(),
        value: 20,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 153,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 52,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 15).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 143,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 50,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 15).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 141,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 51,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 15).toISOString(),
        value: 5,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 142,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 48,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 15).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 139,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 49,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 15).toISOString(),
        value: 9,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 140,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 53,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 15).toISOString(),
        value: 6,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 144,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 42,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 14).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 133,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 38,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 14).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 130,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 40,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 14).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 131,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 41,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 14).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 132,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 45,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 14).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 136,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 46,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 14).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 137,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 47,
        workspaceId: 6,
        userId: 8,
        date: subDays(new Date(), 14).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 138,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 37,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 14).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 128,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 39,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 14).toISOString(),
        value: 8,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 129,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 43,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 14).toISOString(),
        value: 12,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 134,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 44,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 14).toISOString(),
        value: 8,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 135,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 30,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 13).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 118,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 33,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 13).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 120,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 34,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 13).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 123,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 36,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 13).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 125,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 29,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 13).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 119,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 31,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 13).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 121,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 32,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 13).toISOString(),
        value: 9,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 122,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 35,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 13).toISOString(),
        value: 6,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 124,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 24,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 12).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 114,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 26,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 12).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 115,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 27,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 12).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 116,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 23,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 12).toISOString(),
        value: 5,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 113,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 25,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 12).toISOString(),
        value: 22,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 112,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 28,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 12).toISOString(),
        value: 8,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 117,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 20,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 11).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 56,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 21,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 11).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 58,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 18,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 11).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 55,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 19,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 11).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 57,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 22,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 11).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 59,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 13,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 10).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 47,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 15,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 10).toISOString(),
        value: 5,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 48,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 16,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 10).toISOString(),
        value: 5,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 50,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 14,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 10).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 46,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 17,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 10).toISOString(),
        value: 7,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 49,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 8,
        workspaceId: 6,
        userId: 2,
        date: subDays(new Date(), 9).toISOString(),
        value: 2,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 42,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 10,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 9).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 43,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 9,
        workspaceId: 6,
        userId: 9,
        date: subDays(new Date(), 9).toISOString(),
        value: 5,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 41,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 11,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 9).toISOString(),
        value: 14,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 44,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 12,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 9).toISOString(),
        value: 12,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 45,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 5,
        workspaceId: 6,
        userId: 1,
        date: subDays(new Date(), 8).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 38,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 1,
        workspaceId: 6,
        userId: 3,
        date: subDays(new Date(), 8).toISOString(),
        value: 4,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 35,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 3,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 8).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_SENT',
        eventId: 36,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 4,
        workspaceId: 6,
        userId: 4,
        date: subDays(new Date(), 8).toISOString(),
        value: 3,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 37,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 7,
        workspaceId: 6,
        userId: 7,
        date: subDays(new Date(), 8).toISOString(),
        value: 1,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 40,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 2,
        workspaceId: 6,
        userId: 10,
        date: subDays(new Date(), 8).toISOString(),
        value: 8,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 34,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    },
    {
        id: 6,
        workspaceId: 6,
        userId: 11,
        date: subDays(new Date(), 8).toISOString(),
        value: 6,
        type: 'GMAIL_EMAIL_RECEIVED',
        eventId: 39,
        createdAt: subDays(new Date(), 1).toISOString(),
        updatedAt: subDays(new Date(), 1).toISOString()
    }
];
